//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
import Pie from '@/components/pie/Pie.vue'
import Autograph from './components/autograph.vue'
import vote from '@/mixins/vote'
import downloadImgs from '@/mixins/downloadImgs'
export default {
  mixins: [vote, downloadImgs],
  data() {
    return {
      autographValue: '',
      previewList: [],
      rule: {
        custom: {
          autographValue: {
            required: () => '请在上方区域进行签名，并点击【完成】按钮',
          },
        },
      },
    }
  },
  props: {
    question: {
      type: Object,
      default() {
        return {}
      },
    },
    index: {
      type: Number,
    },
    readonly: {
      type: Boolean,
    },
    showScore: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Pie,
  },
  created() {
    // 设置投票， 在 mixins 中
    this.mountedVote()
  },
  mounted() {
    this.$validator.localize('zh_CN', this.rule)
    //已答的题挂上答案
    if (this.question.v_answer) {
      // 图片
      // this.previewList = this.question.v_answer.files
      this.question.v_answer.files.forEach(item => {
        this.downFile(item, data => {
          this.previewList.push(data);
          this.autographValue = [...this.previewList]
        });
      });
    }
  },
  computed: {
    ...mapGetters(['questionnaireList']),
    beforeRouteLeave(to, from, next) {
      if (this.popupItem) {
        this.popupItem.close()
      }
      next()
    },
  },
  watch: {
    autographValue(n) {
      const param = {
        index: this.index,
        v_answered: n && n.length,
      }
      // 设置当前题目已答
      this.$store.commit('setQuestionAnswered', param)

      const v_answer = this.getValue()
      //挂本道题用户答案
      this.$store.commit('setQusstionUserAnswer', {
        index: this.index,
        v_answer,
      })
    },
  },
  methods: {
    reset() {
      let _this = this
      _this.autographValue = []
      _this.previewList = []
      this.openAutograph()
    },
    openAutograph() {
      let _this = this
      const isIPhone = /iphone/gi.test(navigator.appVersion);
      let popup = new this.$Popup(Autograph, {
        position: 'bottom',
        isMaskClose: true,
        size: isIPhone ? '380px' : '360px',
        onchoose(item) {
          if (item) {
            _this.autographValue = [item]
            _this.previewList = [item]
          }
          // _this.pageForm.questions.push(item)
          // _this.saveQuestion(() => {})
          popup.close()
        },
      })
      this.popupItem = popup
    },
    getValue() {
      let files = this.autographValue
      return {
        tenantId: this.question.tenantId,
        type: 'autograph',
        options: [],
        files,
      }
    },
    validate() {
      return this.$validator.validate()
    },
    getDegree(percent) {
      var str = percent.replace('%', '')
      return (str / 100) * 360
    },
    // 下载文件
		downFile(item, fn) {
			this.ssdpRequestDtgw1({
        code: 'survey_download',
        headers: {
          's-crc-tpl-code': 'EMAP_FILE_DOWN',
          'content-type':'application/json',
        },
        params: {
          fileId: item.fileId
        },
        responseType: "blob",
        isUpload: false,
      })
      .then((res) => {
        const blobUrl = URL.createObjectURL(res.data);
        fn({
          ...item,
          url: blobUrl
        });
      });
		}
  },
}
